import { render } from "./Market.vue?vue&type=template&id=b21280a2"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Market.vue?vue&type=style&index=0&id=b21280a2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__